module.exports = __webpack_public_path__ + "static/media/search_1.b33c5f74.svg";